import api from './client';

export const fetchRoles  = () => api.get('/admin/rbac_roles');
export const createRole  = (payload) => api.post('/admin/rbac_roles', payload);
export const updateRole  = (id, payload) => api.put(`/admin/rbac_roles/${id}`, payload);
export const deleteRole  = (id) => api.delete(`/admin/rbac_roles/${id}`);
